// extracted by mini-css-extract-plugin
export default {"ButtonLink":"TodoItemPropertyOccupied_ButtonLink__OaL+x"};